import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaCartPlus } from "react-icons/fa";
import { MyGlobalContext } from "../../Context";
import { toast } from 'react-toastify';

const CocktailArticle = ({ id, img, glass, name, type, category }) => {
  const { add, setIsCartAddBtnClicked } = MyGlobalContext();
  
  const price = parseFloat((id / 5000).toFixed(1));


  return (
    <>
      <article className="inside-cocktail-section">
        <img src={img} alt={name} className="img-main-list" />
        <div className="text-inside-main-cocktail">
          <div className="name-copy-div">
            <h2 className="h2">{name}</h2>
            <h4 className="text-xl text-black backdrop-contrast-200 rounded">${price}</h4>
          </div>
          <h5 className="h5">{glass}</h5>
          <h4 className="h4">Category: {category}</h4>
          <div className="btn-details-div-flex">
            <button className="btn-details">
              <Link to={`/singlecocktail/${id}`} className="btn-details-link">
                Details
              </Link>
            </button>
            <button onClick={() => {
              add(id);
              setIsCartAddBtnClicked(true)
              }} className="btn-details Add-to-cart">
              Add <FaCartPlus />
            </button>
          </div>
        </div>
      </article>
    </>
  );
};

export default CocktailArticle;
